module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    class: _vm.classes
  }, [_c('div', {
    ref: "reference",
    class: _vm.selectionCls,
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._t("input", [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.model
    }
  }), _vm._v(" "), _vm._l((_vm.selectedMultiple), function(item, index) {
    return _c('div', {
      staticClass: "ivu-tag"
    }, [_c('span', {
      staticClass: "ivu-tag-text"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-close-empty"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeTag(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlaceholder && !_vm.filterable),
      expression: "showPlaceholder && !filterable"
    }],
    class: [_vm.prefixCls + '-placeholder']
  }, [_vm._v(_vm._s(_vm.localePlaceholder))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPlaceholder && !_vm.multiple && !_vm.filterable),
      expression: "!showPlaceholder && !multiple && !filterable"
    }],
    class: [_vm.prefixCls + '-selected-value']
  }, [_vm._v(_vm._s(_vm.selectedSingle))]), _vm._v(" "), (_vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    class: [_vm.prefixCls + '-input'],
    style: (_vm.inputStyle),
    attrs: {
      "id": _vm.elementId,
      "type": "text",
      "disabled": _vm.disabled,
      "placeholder": _vm.showPlaceholder ? _vm.localePlaceholder : ''
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "blur": _vm.handleBlur,
      "keydown": [_vm.resetInputState, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
        return _vm.handleInputDelete($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCloseIcon),
      expression: "showCloseIcon"
    }],
    class: [_vm.prefixCls + '-arrow'],
    attrs: {
      "type": "ios-close"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearSingleSelect($event)
      }
    }
  }), _vm._v(" "), (!_vm.remote) ? _c('Icon', {
    class: [_vm.prefixCls + '-arrow'],
    attrs: {
      "type": "arrow-down-b"
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('Drop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropVisible),
      expression: "dropVisible"
    }, {
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    ref: "dropdown",
    class: _vm.dropdownCls,
    attrs: {
      "placement": _vm.placement,
      "data-transfer": _vm.transfer
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notFoundShow),
      expression: "notFoundShow"
    }],
    class: [_vm.prefixCls + '-not-found']
  }, [_c('li', [_vm._v(_vm._s(_vm.localeNotFoundText))])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.notFound && !_vm.remote) || (_vm.remote && !_vm.loading && !_vm.notFound)),
      expression: "(!notFound && !remote) || (remote && !loading && !notFound)"
    }],
    class: [_vm.prefixCls + '-dropdown-list']
  }, [_vm._t("default")], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: [_vm.prefixCls + '-loading']
  }, [_vm._v(_vm._s(_vm.localeLoadingText))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ea6202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/select.vue
// module id = 1408
// module chunks = 107